import type { Locale } from "../types";

type I18nKeys =
  | "close" | "poweredBy"
  | "callback.phoneLabel" | "callback.phonePlaceholder" | "callback.emailLabel" | "callback.emailPlaceholder"
  | "callback.messageLabel" | "callback.messagePlaceholder" | "callback.sendCode" | "callback.sending"
  | "callback.hint" | "callback.verifyTitle" | "callback.verifyInfo" | "callback.resend" | "callback.confirm"
  | "callback.success" | "im.selectChannel" | "im.phoneLabel" | "im.goChat" | "im.hint"
  | "voice.title" | "voice.phoneLabel" | "voice.startCall" | "voice.calling" | "voice.connected" | "voice.ended" | "voice.transferred";

const zh: Record<I18nKeys, string> = {
  close: "关闭", poweredBy: "Powered by OneCall",
  "callback.phoneLabel": "输入您的手机号", "callback.phonePlaceholder": "(555) 123-4567",
  "callback.emailLabel": "✉️ 邮箱（选填）", "callback.emailPlaceholder": "your@email.com",
  "callback.messageLabel": "💬 留言（选填）", "callback.messagePlaceholder": "请输入留言内容...",
  "callback.sendCode": "获取验证码", "callback.sending": "发送中...",
  "callback.hint": "我们将很快回拨给您 · 免费试用",
  "callback.verifyTitle": "✉️ 输入验证码", "callback.verifyInfo": "验证码已发送至 %s ****-%s",
  "callback.resend": "重新发送", "callback.confirm": "请求回拨",
  "callback.success": "✅ 回拨请求已提交，请留意手机来电",
  "im.selectChannel": "请选择沟通方式", "im.phoneLabel": "您的手机号（用于线索记录）",
  "im.goChat": "开始对话", "im.hint": "点击后将跳转到对应平台",
  "voice.title": "AI 语音接待", "voice.phoneLabel": "输入您的手机号",
  "voice.startCall": "AI 语音回拨", "voice.calling": "正在呼叫...",
  "voice.connected": "通话中", "voice.ended": "通话已结束", "voice.transferred": "已转接人工客服",
};

const en: Record<I18nKeys, string> = {
  close: "Close", poweredBy: "Powered by OneCall",
  "callback.phoneLabel": "Enter your phone number", "callback.phonePlaceholder": "(555) 123-4567",
  "callback.emailLabel": "✉️ Email (optional)", "callback.emailPlaceholder": "your@email.com",
  "callback.messageLabel": "💬 Message (optional)", "callback.messagePlaceholder": "Leave a message...",
  "callback.sendCode": "Send Verification Code", "callback.sending": "Sending...",
  "callback.hint": "We'll call you back soon · Free trial",
  "callback.verifyTitle": "✉️ Enter verification code", "callback.verifyInfo": "Code sent to %s ****-%s",
  "callback.resend": "Resend", "callback.confirm": "Request Callback",
  "callback.success": "✅ Callback requested. Please wait for the call.",
  "im.selectChannel": "Select a channel", "im.phoneLabel": "Your phone (for lead tracking)",
  "im.goChat": "Start Chat", "im.hint": "You will be redirected to the platform",
  "voice.title": "AI Voice Assistant", "voice.phoneLabel": "Enter your phone number",
  "voice.startCall": "AI Voice Call", "voice.calling": "Calling...",
  "voice.connected": "Connected", "voice.ended": "Call ended", "voice.transferred": "Transferred to human agent",
};

const bundles: Record<Locale, Record<I18nKeys, string>> = { "zh-CN": zh, "en-US": en };

export function t(key: I18nKeys, locale: Locale, ...args: string[]): string {
  const bundle = bundles[locale] || bundles["zh-CN"];
  let text = bundle[key] || key;
  for (let i = 0; i < args.length; i++) text = text.replace("%s", args[i]);
  return text;
}
